import React, {PropTypes} from 'react';
import Infobox from '../Containers/Infobox';
import Map from '../Containers/Map';
import Menu from '../Containers/Menu';
import Modals from '../Containers/Modals';
import Selection from '../Containers/Selection';
import SelectionOptions from '../containers/SelectionOptions';
import UserLocation from '../Containers/UserLocation';
import Welcome from '../Containers/Welcome';

class Home extends React.Component {

  constructor() {
    super();
    this.updateHeights = this.updateHeights.bind(this);
    this.updateWidths = this.updateWidths.bind(this);
    this.updateBoth = this.updateBoth.bind(this);
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateBoth);
    this.updateBoth();

    // Dirty hack compensating for the fact that the height of the menu bar changes when its own
    // contents get loaded in the DOM
    setTimeout(this.updateHeights, 100);
    setTimeout(this.updateHeights, 1000);
    setTimeout(this.updateHeights, 3000);
    setTimeout(this.updateHeights, 10000);
  }

  componentDidUpdate () {
    this.updateWidths();
  }

  /*
  * Adjust map + infobox heights depending on the browser's size
  */
  updateHeights () {
    // Manage heights by directly manipulating them
    let windowHeight = $(window).height();
    let menuContainerHeight = $('.menu-container').height();
    let contentHeight = windowHeight - menuContainerHeight;
    $('.map-container').css('height', contentHeight);
  }

  /*
  * Adjust menu depending on the width available for it
  */
  updateWidths () {
    // Manage width of the menu depending if selection is open or not
    if(this.props.selection.displayed) {
      $('.menu-container').css('width', '45%');
    }
    else {
      $('.menu-container').css('width', '100%');
    }

    // Manage width of the slider
    let menuWidth = $('.menu-container').width();
    if(menuWidth > 600) {
      $('#slider').css('width', '380px');
    }
    else {
      $('#slider').css('width', '60%');
    }

    // Manage display of the logo
    if(menuWidth > 750) {
      $('.logo-container').css('display', 'block');
    }
    else {
      $('.logo-container').css('display', 'none');
    }

    // Manage display of the "built by"
    if(menuWidth > 750) {
      $('.links-container').css('display', 'block');
    }
    else {
      $('.links-container').css('display', 'none');
    }

  }

  updateBoth () {
    this.updateWidths();
    this.updateHeights();
  }

  render() {
    return (
      <div>
        <UserLocation />
        <Welcome />
        <Modals />
        <Map />
        <Infobox />
        <Selection />
        <SelectionOptions />
        <Menu />
      </div>
    );
  }
}

Home.propTypes = {
  selection: PropTypes.object.isRequired,
  userLocationActions: PropTypes.object.isRequired
};

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Home.js
 **/